import { Heading } from "@otta/design";

export function QuizHeading({ children }: React.PropsWithChildren<unknown>) {
  return <Heading size={2}>{children}</Heading>;
}
